import { useContext } from 'react';
import { FirebaseContext, IFirebaseContext } from './FirebaseProvider';

// light wrapper around FirebaseProvider so we can use it as a custom hook
const useFirebase = () => {
    return useContext(FirebaseContext) as IFirebaseContext;
}

export default useFirebase;